var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 67.4 67.4",
    style: {
      enableBackground: "new 0 0 67.4 67.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#007EBB;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "git",
    transform: "translate(-2.555 -2.558)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.7,67.4L33.7,67.4c18.6,0,33.7-15.1,33.7-33.7l0,0C67.4,15.1,52.3,0,33.7,0l0,0C15.1,0,0,15.1,0,33.7l0,0 C0,52.3,15.1,67.4,33.7,67.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.2,53.4h-8.5V38.9c0-4-1.5-6.2-4.6-6.2c-3.4,0-5.2,2.3-5.2,6.2v14.4h-8.2V25.9H37v3.7c0,0,2.5-4.5,8.3-4.5 c5.8,0,10,3.6,10,10.9V53.4z M19.1,22.3c-2.8,0-5-2.3-5-5.1s2.3-5.1,5-5.1s5,2.3,5,5.1S21.8,22.3,19.1,22.3z M14.9,53.4h8.5V25.9 h-8.5V53.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.689c5e876eb57d3ab8dbf88057019416.svg";
export { ForwardRef as ReactComponent };